import React from "react"
import { Header, NoDataComponent, SkeletonTable, StatusBadge } from "../../components"
import { useState, useEffect } from "react"
import DataTable from "react-data-table-component"
import { Setup } from "./SetupMetrics"
import { Button } from "../../components/adminDashboard/ResultsComponents"
import CustomPagination from "../../components/CustomPagination/CustomPagination"
import { MdInfo, MdSearch } from "react-icons/md"
import { FiFileText, FiMoreVertical, FiUpload, FiDownload, FiX, FiLayers } from "react-icons/fi"
import { useStateContext } from "../../contexts/ContextProvider"
import { userRequest } from "../../utils/requestMethods"
import { Link, useHistory } from "react-router-dom"
import ResultSettings from "../../components/adminDashboard/ResultSettings"
import { generateSchoolSessions } from "../../utils/schoolYearUtils"
import BroadsheetModal from "../../components/adminDashboard/BroadsheetModal"

const customStyles = {
  headRow: {
    style: {
      backgroundColor: 'rgb(248, 250, 252)',
      fontWeight: "bold",
      color: "#5C5C5C",
    },
  },
}

const ResultManagement = () => {
  //const [filter, setFilter] = useState("All Classes");
  const [viewSetup, setViewSetup] = useState(false);
  const [viewSettings, setViewSettings] = useState(false);
  const [showBroadsheetModal, setShowBroadsheetModal] = useState(false);
  const [dismissedCumulativeBanner, setDismissedCumulativeBanner] = useState(false);
  const { school } = useStateContext();
  console.log(school?.settings);
  const schoolTerm = school?.settings?.current_term;
  const schoolSession = school?.settings?.current_session;
  const terminology = school?.settings?.term_terminology;
  const [filterText, setFilterText] = useState('');
  //const [students, setStudents] = useState([]);
  const [classResult, setClassResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [dropdown, setDropdown] = useState(false);
  const [actionsDropdown, setActionsDropdown] = useState(false);
  const [selectedClass, setSelectedClass] = useState(() => {
    const savedClass = JSON.parse(localStorage.getItem('selectedClass'));
    return savedClass || { id: '', name: 'Select Class' };
  });
  const handleDropdown = () => setDropdown(!dropdown);
  const handleActionsDropdown = () => setActionsDropdown(!actionsDropdown);
  const history = useHistory();

  // Get assessment system based on selected class's level of education
  const getAssessmentSystemForClass = (classObj) => {
    if (!classObj?.level_of_education || !school?.settings?.assessment?.assessment_system) {
      // No assessment system available, fallback to default CA structure
      return { ca: { cas: [] }, exam: { max_score: 100 } };
    }

    const levelOfEducation = classObj.level_of_education;

    // Find the assessment system for this level of education
    const assessmentConfig = school.settings.assessment.assessment_system.find(
      (config) => config.level_of_education === levelOfEducation
    );

    // If found, use it; otherwise, use the default one
    if (assessmentConfig) {
      return assessmentConfig;
    }

    // Fallback to default assessment system
    const defaultConfig = school.settings.assessment.assessment_system.find(
      (config) => config.is_default === true
    );

    return defaultConfig || { ca: { cas: [] }, exam: { max_score: 100 } };
  };

  // Get the full class object from classes array
  const selectedClassObj = selectedClass.id
    ? classes.find(c => c._id === selectedClass.id)
    : null;

  // Get CA settings and exam max score based on selected class
  const currentAssessmentSystem = selectedClassObj
    ? getAssessmentSystemForClass(selectedClassObj)
    : { ca: { cas: [] }, exam: { max_score: 100 } };

  const caSettings = currentAssessmentSystem?.ca?.cas || [];
  const examMaxScore = currentAssessmentSystem?.exam?.max_score || 100;

  useEffect(() => {
    const fetchClasses = async () => {
      if (school) {
        try {
          setLoading(true);
          const { data } = await userRequest.get(`classes?code=${school?.code}`);
          setClasses(data.classes || []);
        } catch (error) {
          console.error("Error fetching classes:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchClasses();
  }, [school]);

  /*const fetchStudents = async () => {
    setLoading(true);
    try {
      const { data } = await userRequest.get(`children/class/${selectedClass.id || ''}?limit=200`);
      console.log(data.children);
      setStudents(data.children);
    } catch (error) {
      console.error("Error fetching attendance:", error);
    } finally {
      setLoading(false);
    }
  };*/

  const [subjects, setSubjects] = useState([]);
  const [subjectDropdown, setSubjectDropdown] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(() => {
    const saved = JSON.parse(localStorage.getItem('selectedSubject'));
    return saved || { id: '', name: 'All Subjects' };
  });

  // Term and Session filter states
  const [termDropdown, setTermDropdown] = useState(false);
  const [sessionDropdown, setSessionDropdown] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(() => {
    const saved = JSON.parse(localStorage.getItem('selectedTerm'));
    return saved || { id: schoolTerm || '1', name: `Term ${schoolTerm || '1'}` };
  });
  const [selectedSession, setSelectedSession] = useState(() => {
    const saved = JSON.parse(localStorage.getItem('selectedSession'));
    return saved || { id: schoolSession || '2024/2025', name: schoolSession || '2024/2025' };
  });

  // Generate school sessions using utility function
  const schoolSessions = generateSchoolSessions(2020, 10); // Generate sessions from 2020 to 2030

  // Fetch subjects for selected class
  useEffect(() => {
    const fetchSubjects = async () => {
      if (selectedClass.id && school?._id) {
        try {
          setLoading(true);
          const { data } = await userRequest.get(`/subjects/${school?._id}/${selectedClass.id}?limit=100`);
          setSubjects(data.subjects || []);
        } catch (error) {
          setSubjects([]);
        } finally {
          setLoading(false);
        }
      } else {
        setSubjects([]);
      }
    };
    fetchSubjects();
  }, [selectedClass.id, school?._id]);

  // Update fetchClassResult to use selected filters
  const fetchClassResult = async () => {
    setLoading(true);
    try {
      const subjectId = selectedSubject.id || '';
      const term = selectedTerm.id || schoolTerm || '1';
      const session = selectedSession.id || schoolSession || '2024/2025';
      const { data } = await userRequest.get(`result/${school?._id}?class_id=${selectedClass.id || ''}&subject_id=${subjectId}&term=${term}&session=${session}&limit=100`);
      setClassResult(data);
    } catch (error) {
      setClassResult([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedClass.id && school?._id && selectedSubject.id) {
      //fetchStudents();
      fetchClassResult();
    }
  }, [school?._id, selectedClass.id, selectedSubject.id, selectedTerm.id, selectedSession.id]);


  const handleClassSelection = (id, name) => {
    const newSelection = { id, name };
    setSelectedClass(newSelection);
    localStorage.setItem('selectedClass', JSON.stringify(newSelection));
    setDropdown(false);
  };

  const handleSubjectDropdown = () => setSubjectDropdown(!subjectDropdown);
  const handleSubjectSelection = (id, name) => {
    const newSelection = { id, name };
    setSelectedSubject(newSelection);
    localStorage.setItem('selectedSubject', JSON.stringify(newSelection));
    setSubjectDropdown(false);
  };

  // Term and Session handlers
  const handleTermDropdown = () => setTermDropdown(!termDropdown);
  const handleSessionDropdown = () => setSessionDropdown(!sessionDropdown);

  const handleTermSelection = (id, name) => {
    const newSelection = { id, name };
    setSelectedTerm(newSelection);
    localStorage.setItem('selectedTerm', JSON.stringify(newSelection));
    setTermDropdown(false);
  };

  const handleSessionSelection = (id, name) => {
    const newSelection = { id, name };
    setSelectedSession(newSelection);
    localStorage.setItem('selectedSession', JSON.stringify(newSelection));
    setSessionDropdown(false);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdown || subjectDropdown || termDropdown || sessionDropdown || actionsDropdown) {
        if (!event.target.closest('.dropdown-container')) {
          setDropdown(false);
          setSubjectDropdown(false);
          setTermDropdown(false);
          setSessionDropdown(false);
          setActionsDropdown(false);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdown, subjectDropdown, termDropdown, sessionDropdown, actionsDropdown]);

  // --- Class Result Columns ---
  // Dynamically build CA columns based on education level-based assessment system
  const caColumns = Array.isArray(caSettings) && caSettings.length > 0
    ? caSettings.map((ca, idx) => ({
      name: ca.title ? `${ca.title} (${ca.max_score})` : `CA ${idx + 1} (${ca.max_score})`,
      selector: (row) => {
        const caObj = Array.isArray(row.results?.[0]?.cas) ? row.results[0].cas.find(c => c.ca === idx + 1) : null;
        return caObj ? caObj.score : 0;
      },
    }))
    : [];

  const classResultColumns = [
    { name: "Surname", selector: row => row.child?.lastname },
    { name: "First Name", selector: row => row.child?.firstname },
    { name: "Gender", selector: row => row.child?.gender },
    ...caColumns,
    { name: `Exam (${examMaxScore})`, selector: row => row.results?.[0]?.exam },
    { name: "Total", selector: row => row.results?.[0]?.total },
    { name: "Grade", selector: row => row.results?.[0]?.grade },
    { name: "Class Avg", selector: row => row.results?.[0]?.class_average },
    { name: "Position", selector: row => row.results?.[0]?.subject_rank },
    { name: "Remark", selector: row => row.remark },
    {
      name: 'Action',
      cell: (row) => (
        <Link to={{ pathname: `/students/view/${row.child?._id}/${selectedClass.id}`, state: { student: row.child?.firstname + " " + row.child?.lastname } }} className="font-medium text-[#00509D] hover:font-semibold">View Result</Link>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  // Filter and sort class result data by lastname
  const filteredData = classResult?.data?.filter((item) =>
    (item.child?.firstname?.toLowerCase().includes(filterText.toLowerCase()) || '') ||
    (item.child?.lastname?.toLowerCase().includes(filterText.toLowerCase()) || '')
  ).sort((a, b) => {
    // Sort by lastname alphabetically
    const lastNameA = (a.child?.lastname || '').toLowerCase();
    const lastNameB = (b.child?.lastname || '').toLowerCase();
    return lastNameA.localeCompare(lastNameB);
  });

  return (
    <div>
      <div className="m-2 mt-24 md:mx-10 md:my-0 py-2 md:py-7 flex flex-wrap gap-4 justify-between items-start">
        <Header category="Set Up" title="Result Management" />
        <div className="flex gap-4">
          <Button onClick={() => setViewSettings(true)}>
            <MdInfo />
            View Result Settings
          </Button>
          <Button onClick={() => history.push('/result-management/add-metrics')}>
            <img alt="icon" src="/settings-04.svg" />
            {school?.settings && Object.keys(school.settings).length > 0 ? 'Update Result Metrics' : 'Configure Result Metrics'}
          </Button>
          {/*<Button onClick={() => setViewSetup(true)}>
            <img alt="icon" src="/settings-04.svg"/>
            Edit Result Metrics
          </Button>
          <Button onClick={() => history.push(`/result-management/settings`)}>
            <img alt="icon" src="/settings-04.svg"/>
          </Button>*/}
        </div>
      </div>

      {!school?.settings?.cumulative_result && !dismissedCumulativeBanner && (
        <div className="mx-2 md:mx-10 mb-2">
          <div className="flex items-start gap-4 bg-indigo-50 border border-indigo-200 rounded-2xl px-5 py-4">
            <div className="flex-shrink-0 w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
              <FiLayers className="w-5 h-5 text-indigo-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-indigo-900">Cumulative Results not enabled</p>
              <p className="text-sm text-indigo-700 mt-0.5">
                Enable cumulative results to include all previous terms in student end-of-year reports — useful for schools that want a full-session summary.
              </p>
              <button
                onClick={() => history.push('/result-management/add-metrics', { openSection: 'customization' })}
                className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-indigo-600 hover:text-indigo-800 underline underline-offset-2 transition-colors"
              >
                Go to Result Metrics to enable it →
              </button>
            </div>
            <button
              onClick={() => setDismissedCumulativeBanner(true)}
              className="flex-shrink-0 text-indigo-400 hover:text-indigo-600 transition-colors mt-0.5"
            >
              <FiX className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      <div className="my-2 mx-2 md:mx-10 flex flex-wrap justify-around gap-7">
        {school?.settings?.terms.map(term =>
          <TermResult term={term.term} start={term.start_date} end={term.end_date} terminology={school?.settings?.term_terminology} />
        )}
      </div>

      <div className="m-2 md:mx-10 md:my-8 p-2 md:p-10 bg-white rounded-3xl dark:bg-secondary-dark-bg min-h-screen">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4">
          <h1 className="text-2xl font-extrabold tracking-tight text-slate-900 dark:text-gray-200">
            Result History
          </h1>

          {/* Term and Session Filters */}
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
            {/* Term Filter */}
            <div className="relative dropdown-container">
              <button
                type='button'
                onClick={handleTermDropdown}
                className='w-full sm:w-auto sm:max-w-[180px] text-sm font-semibold flex items-center justify-between bg-white hover:bg-indigo-50 border-2 border-indigo-200 hover:border-indigo-300 py-2.5 px-4 rounded-xl transition-all duration-200 min-w-0'
              >
                <span className='mr-2 truncate min-w-0'>Term: {selectedTerm.name}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`inline ml-2 flex-shrink-0 transition-transform duration-200 ${termDropdown ? 'rotate-180' : ''}`}
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              </button>
              {termDropdown && (
                <div className="absolute left-0 right-0 sm:left-auto sm:right-0 bg-white border-2 border-indigo-200 rounded-xl shadow-xl mt-2 z-20 max-h-60 overflow-y-auto min-w-full sm:min-w-40 sm:max-w-[180px]">
                  {[1, 2, 3].map(termNum => (
                    <div
                      key={termNum}
                      onClick={() => handleTermSelection(termNum.toString(), `Term ${termNum}`)}
                      className="cursor-pointer text-sm px-4 py-3 hover:bg-indigo-50 hover:font-semibold transition-colors border-b border-slate-100 last:border-b-0 truncate"
                    >
                      Term {termNum}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Session Filter */}
            <div className="relative dropdown-container">
              <button
                type='button'
                onClick={handleSessionDropdown}
                className='w-full sm:w-auto sm:max-w-[200px] text-sm font-semibold flex items-center justify-between bg-white hover:bg-indigo-50 border-2 border-indigo-200 hover:border-indigo-300 py-2.5 px-4 rounded-xl transition-all duration-200 min-w-0'
              >
                <span className='mr-2 truncate min-w-0'>Session: {selectedSession.name}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`inline ml-2 flex-shrink-0 transition-transform duration-200 ${sessionDropdown ? 'rotate-180' : ''}`}
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              </button>
              {sessionDropdown && (
                <div className="absolute left-0 right-0 sm:left-auto sm:right-0 bg-white border-2 border-indigo-200 rounded-xl shadow-xl mt-2 z-20 max-h-60 overflow-y-auto min-w-full sm:min-w-48 sm:max-w-[200px]">
                  {schoolSessions.map(session => (
                    <div
                      key={session.value}
                      onClick={() => handleSessionSelection(session.value, session.label)}
                      className="cursor-pointer text-sm px-4 py-3 hover:bg-indigo-50 hover:font-semibold transition-colors border-b border-slate-100 last:border-b-0 truncate"
                      title={session.label}
                    >
                      {session.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='w-full'>
          <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6'>
            {/* Filters Section - Mobile Responsive */}
            <div className='flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto'>
              {/* Class Filter Dropdown */}
              <div className="relative flex-1 sm:flex-none dropdown-container">
                <button
                  type='button'
                  onClick={handleDropdown}
                  className='w-full sm:w-auto sm:max-w-[200px] text-sm font-semibold flex items-center justify-between bg-white hover:bg-indigo-50 border-2 border-indigo-200 hover:border-indigo-300 py-2.5 px-4 rounded-xl transition-all duration-200 active:scale-[0.98] min-w-0'
                >
                  <span className='flex items-center gap-2 min-w-0 flex-1'>
                    <span className="text-slate-600 font-medium flex-shrink-0">Class:</span>
                    <span className="text-indigo-700 truncate min-w-0">{selectedClass.name}</span>
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`ml-2 flex-shrink-0 transition-transform duration-200 ${dropdown ? 'rotate-180' : ''}`}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M6 9l6 6l6 -6" />
                  </svg>
                </button>
                {dropdown && (
                  <div className="absolute left-0 right-0 sm:left-auto sm:right-0 bg-white border-2 border-indigo-200 rounded-xl shadow-xl mt-2 z-20 max-h-60 overflow-y-auto min-w-full sm:min-w-48 sm:max-w-[200px]">
                    <div
                      onClick={() => handleClassSelection('', 'Select Class')}
                      className="cursor-pointer text-sm px-4 py-3 hover:bg-indigo-50 hover:font-semibold transition-colors border-b border-slate-100 truncate"
                    >
                      Select Class
                    </div>
                    {classes.map(classe => (
                      <div
                        key={classe._id}
                        onClick={() => handleClassSelection(classe._id, classe.class_name)}
                        className="cursor-pointer text-sm px-4 py-3 hover:bg-indigo-50 hover:font-semibold transition-colors border-b border-slate-100 last:border-b-0 truncate"
                        title={classe.class_name}
                      >
                        {classe.class_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Subject Filter Dropdown */}
              <div className="relative flex-1 sm:flex-none dropdown-container">
                <button
                  type='button'
                  onClick={handleSubjectDropdown}
                  className='w-full sm:w-auto sm:max-w-[200px] text-sm font-semibold flex items-center justify-between bg-white hover:bg-indigo-50 border-2 border-indigo-200 hover:border-indigo-300 py-2.5 px-4 rounded-xl transition-all duration-200 active:scale-[0.98] min-w-0'
                >
                  <span className='flex items-center gap-2 min-w-0 flex-1'>
                    <span className="text-slate-600 font-medium flex-shrink-0">Subject:</span>
                    <span className="text-indigo-700 truncate min-w-0">{selectedSubject.name}</span>
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`ml-2 flex-shrink-0 transition-transform duration-200 ${subjectDropdown ? 'rotate-180' : ''}`}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M6 9l6 6l6 -6" />
                  </svg>
                </button>
                {subjectDropdown && (
                  <div className="absolute left-0 right-0 sm:left-auto sm:right-0 bg-white border-2 border-indigo-200 rounded-xl shadow-xl mt-2 z-20 max-h-60 overflow-y-auto min-w-full sm:min-w-48 sm:max-w-[200px]">
                    <div
                      onClick={() => handleSubjectSelection('', 'Select Subject')}
                      className="cursor-pointer text-sm px-4 py-3 hover:bg-indigo-50 hover:font-semibold transition-colors border-b border-slate-100 truncate"
                    >
                      Select Subject
                    </div>
                    {subjects.map(subject => (
                      <div
                        key={subject._id}
                        onClick={() => handleSubjectSelection(subject._id, subject.subject_name)}
                        className="cursor-pointer text-sm px-4 py-3 hover:bg-indigo-50 hover:font-semibold transition-colors border-b border-slate-100 last:border-b-0 truncate"
                        title={subject.subject_name}
                      >
                        {subject.subject_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Action Section - Mobile Responsive */}
            <div className='flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto'>
              {/* Search Bar */}
              <div className="relative flex-1 sm:flex-none sm:min-w-[250px]">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <MdSearch className="w-5 h-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  className="w-full bg-white border-2 border-gray-200 hover:border-indigo-300 focus:border-indigo-500 text-sm text-gray-900 rounded-xl focus:ring-2 focus:ring-indigo-200 block pl-10 pr-4 py-2.5 transition-all duration-200"
                  placeholder="Search students..."
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>

              {/* Actions Dropdown */}
              <div className="relative flex-shrink-0 dropdown-container">
                <button
                  type='button'
                  onClick={handleActionsDropdown}
                  className='w-full sm:w-auto text-sm font-semibold flex items-center justify-between bg-white hover:bg-indigo-50 border-2 border-indigo-200 hover:border-indigo-300 py-2.5 px-4 rounded-xl transition-all duration-200 active:scale-[0.98]'
                >
                  <span className='flex items-center gap-2'>
                    <FiMoreVertical className="w-4 h-4 text-indigo-600" />
                    <span className="text-indigo-700 font-medium">Actions</span>
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`ml-2 flex-shrink-0 transition-transform duration-200 ${actionsDropdown ? 'rotate-180' : ''}`}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M6 9l6 6l6 -6" />
                  </svg>
                </button>
                {actionsDropdown && (
                  <div className="absolute right-0 sm:right-0 bg-white border-2 border-indigo-200 rounded-xl shadow-xl mt-2 z-20 min-w-[200px] overflow-hidden">
                    <button
                      onClick={() => {
                        history.push('/result-management/upload-class-result');
                        setActionsDropdown(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 transition-colors border-b border-slate-100"
                    >
                      <FiUpload className="w-4 h-4 flex-shrink-0" />
                      <span>Upload Class Result</span>
                    </button>
                    <button
                      onClick={() => {
                        setShowBroadsheetModal(true);
                        setActionsDropdown(false);
                      }}
                      className="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 transition-colors"
                    >
                      <FiDownload className="w-4 h-4 flex-shrink-0" />
                      <span>Download Broadsheet</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto w-full max-w-screen-lg mx-auto">
          <div className="border rounded-3xl mt-12">
            <DataTable
              columns={classResultColumns}
              data={filteredData || []}
              noDataComponent={<NoDataComponent />}
              pagination
              paginationComponent={CustomPagination}
              paginationRowsPerPageOptions={[10, 20, 30, 50]}
              customStyles={customStyles}
              progressPending={loading}
              progressComponent={<SkeletonTable rows={5} columns={6} />}
              highlightOnHover
              striped
            />
          </div>
        </div>

        {viewSetup && <Setup onClose={() => setViewSetup(false)} />}
        {viewSettings && <ResultSettings onClose={() => setViewSettings(false)} settings={school?.settings} />}

        {/* Broadsheet Download Modal */}
        <BroadsheetModal
          isOpen={showBroadsheetModal}
          onClose={() => setShowBroadsheetModal(false)}
        />
      </div>
    </div>
  )
};

const TermResult = ({ term, start, end, onClick, terminology }) => {
  return (
    <div className="p-6 flex-1 bg-white min-w-[300px] rounded-3xl">
      <img alt="icon" src="/checklist.svg" className="block mb-8" />
      <h2 className="my-3 text-2xl font-semibold">
        {term === 1 ? "1st" : term === 2 ? "2nd" : "3rd"} {terminology ? terminology : "Term"}
      </h2>

      <div className="flex justify-between items-center mb-4">
        <p className="text-[#656565] text-sm"><b>Start:</b> {(new Date(start)).toLocaleDateString('en-NG')}</p>
        <p className="text-[#656565] text-sm"><b>End:</b> {(new Date(end)).toLocaleDateString('en-NG')}</p>
      </div>

      <Button variant={2} full>View Term Result</Button>
    </div>
  )
};

export default ResultManagement